import {
  AppFooter_v2 as AppFooter,
  Button_v2 as Button,
  Container_v2 as Container,
  AppHeader_v2 as AppHeader,
  Typography,
  TypographyVariantsEnum,
} from '@mindly/ui-components';
import { useTranslation } from 'react-i18next';

type ProfileNeedUpdateWidgetProps = {
  onSubmit: () => void;
};

export function ProfileNeedUpdateWidget({ onSubmit }: ProfileNeedUpdateWidgetProps) {
  const {
    t,
  } = useTranslation('profile');
  return (
    <>
      <AppHeader />
      <Container>
        <div className="flex flex-col h-full justify-center items-center">
          <div>
            <Typography align="center" className="text-[104px]">
              🧩
            </Typography>
            <Typography variant={TypographyVariantsEnum.Title24Semi} className="mt-2" align="center">
              {t("update_profile_alert.title")}
            </Typography>
            <Typography variant={TypographyVariantsEnum.Text14Regular} className="mt-2" align="center" opacity={50}>
              {t("update_profile_alert.description")}
            </Typography>
          </div>
        </div>
      </Container>
      <AppFooter>
        <Button size="large" fullWidth onClick={onSubmit}>
          {t("update_profile_alert.button")}
        </Button>
      </AppFooter>
    </>
  );
}
